import { getHelpUrlBasedOnLocale } from '@@/bits/current_locale'

const getPiHelpdocsUrl = (): string => {
  return `${getHelpUrlBasedOnLocale()}/article/5euyj9505g`
}

const getFeedbackFormUrl = (): string => {
  return 'https://forms.gle/tMN7AF4by7HniVTN8'
}

/**
 * SourcedFile is a wrapper around the File class that makes the size property writable.
 * It was built for convenience when dealing with different uploads:
 * - Native uploads are proper File objects.
 * - Google Drive uploads are just a URL.
 */
class SourcedFile extends File {
  declare url?: string
  declare size: number

  constructor(fileBits: BlobPart[], fileName: string, options: FilePropertyBag = {}) {
    super(fileBits, fileName, options)
    Object.defineProperty(this, 'size', {
      value: super.size,
      writable: true,
      configurable: true,
      enumerable: true,
    })
  }
}

export { getFeedbackFormUrl, getPiHelpdocsUrl, SourcedFile }
